// extracted by mini-css-extract-plugin
export default {"name":"PromotionRow__name-QeuRf"};